import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { StocksEditProfileModalModule } from 'CompanyApp/ts/apps/stocks-edit-profile-modal-app/stocks-edit-profile-modal.module';
import * as i0 from "@angular/core";
export class StocksEditProfileModalButtonModule {
}
StocksEditProfileModalButtonModule.ɵfac = function StocksEditProfileModalButtonModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || StocksEditProfileModalButtonModule)(); };
StocksEditProfileModalButtonModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: StocksEditProfileModalButtonModule });
StocksEditProfileModalButtonModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [StocksEditProfileModalModule, IconModule] });
